import axios from '../../../util/CustomAxios';

/**
 * 데모 기기 추가
 * @param {Object} data - 기기의 정보
 * @param {string} data.macAddress - 기기의 MAC 주소
 * @param {string} data.model - 기기의 모델 이름
 * @param {string} data.memo - 기기의 메모
 */
export const addDemoDevice = async (data) => {
  await axios.post('/demo', data);
};

/**
 * @typedef {Object} DemoDevice
 * @property {number} id - 기기의 ID
 * @property {string} macAddress - 기기의 MAC 주소
 * @property {string} model - 기기의 모델 이름
 * @property {string} memo - 기기의 메모
 * @property {Object} createInfo - 기기의 생성 정보
 * @property {number} createInfo.userId - 기기의 생성자 ID
 * @property {string} createInfo.name - 기기의 생성자 이름
 * @property {string} createInfo.at - 기기의 생성 일시
 * @property {Object} updateInfo - 기기의 수정 정보
 * @property {number} updateInfo.userId - 기기의 수정자 ID
 * @property {string} updateInfo.name - 기기의 수정자 이름
 * @property {string} updateInfo.at - 기기의 수정 일시
 * @property {Object} deleteInfo - 기기의 삭제 정보
 * @property {number} deleteInfo.userId - 기기의 삭제자 ID
 * @property {string} deleteInfo.name - 기기의 삭제자 이름
 * @property {string} deleteInfo.at - 기기의 삭제 일시
 *
 * 데모 기기 검색
 * @param {object} params - 검색 조건
 * @param {string} params.macAddress - 기기의 MAC 주소
 * @param {string} params.model - 기기의 모델 이름
 * @returns {Promise<Array>} - 검색된 기기 목록
 */
export const searchDemoDevices = async (params) => {
  const response = await axios.get('/demo', {
    params,
  });
  return response.data;
};

/**
 * 데모 기기 삭제
 * @param {number} id - 기기의 ID
 */
export const deleteDemoDevice = async (id) => {
  await axios.delete(`/demo/${id}`);
};

/**
 * 데모 기기 정보 업데이트
 * @param {number} id - 기기의 ID
 * @param {object} data - 기기의 정보
 * @param {string} data.macAddress - 기기의 MAC 주소
 * @param {string} data.model - 기기의 모델 이름
 * @param {string} data.memo - 기기의 메모
 */
export const updateDemoDevice = async (id, data) => {
  await axios.patch(`/demo/${id}`, data);
};

/**
 * 데모 기기 모델 목록 조회
 * @returns {string[]} - 데모 기기 모델 목록
 */
export const getDemoModelList = async () => {
  const response = await axios.get('/demo/model');
  return response.data;
};
